"use strict";
/*
 * Copyright 2018 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChainInfo = void 0;
/**
 * The chain information.
 */

var ChainInfo = /*#__PURE__*/_createClass(
/**
 * @param height
 * @param scoreLow
 * @param scoreHigh
 * @param latestFinalizedBlock
 */
function ChainInfo(
/**
 * Current chain height.
 */
height,
/**
 * Low part of the blockchain score.
 */
scoreLow,
/**
 * High part of the blockchain score.
 */
scoreHigh,
/**
 * Latest finalized block.
 */
latestFinalizedBlock) {
  _classCallCheck(this, ChainInfo);

  this.height = height;
  this.scoreLow = scoreLow;
  this.scoreHigh = scoreHigh;
  this.latestFinalizedBlock = latestFinalizedBlock;
});

exports.ChainInfo = ChainInfo;